import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import {Auth0Provider} from "@auth0/auth0-react";
import {Provider} from "react-redux";
import store from "./store";
import {ROUTESLIST} from "./static/urls";
import * as Sentry from "@sentry/react";
import MaintenanceGate from "./pages/maintenance/gate";
//import * as serviceWorker from './serviceWorker';

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
// Maintenance mode check - controlled by .env file
const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === "true";

Sentry.init({
    dsn: "https://e155e81cd4934db18c5bb1b6033896de@errors.lightlink.site/4",
// Setting this option to true will send default PII data to Sentry.
// For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
        Sentry.browserTracingIntegration()
    ],
// Tracing
    tracesSampleRate: 1.0, // Capture 100% of the transactions
// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/api.theamplesamples\.com\/api/],
// Enable logs to be sent to Sentry
    enableLogs: true
});

ReactDOM.render(
    <React.StrictMode>
        <MaintenanceGate forced={isMaintenanceMode}>
            <Provider store={store}>
                <Auth0Provider
                    domain={domain}
                    clientId={clientId}
                    authorizationParams={{
                        // redirect_uri: `${window.location.origin}/userdashboard`,
                        redirect_uri: `${window.location.origin}${ROUTESLIST.CLEAR_SAMPLE}`,
                    }}
                >
                    <App/>
                </Auth0Provider>
            </Provider>
        </MaintenanceGate>
    </React.StrictMode>,
    document.getElementById("as-app")
);

//https://stackoverflow.com/questions/59331493/combine-react-build-output-into-single-js-file
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
